export const IMAGE_VARIANTS = {
  square: 1,
  banner: 16 / 9,
  thumbnail: 4 / 3,
  portrait: 3 / 4
};
